import axios from "axios";
import {memoizedRefreshToken} from "./refreshToken";
import {getFingerprint} from "./auth";
import {getLocation} from "./common";

const axiosConfig = {
    baseURL: process.env.REACT_APP_SERVICE_URL,
    headers: {
        'Content-Type': 'application/json',
    }
}

const requestv2 = axios.create(axiosConfig)

requestv2.interceptors.request.use(
    async (config) => {

        const storedToken = JSON.parse(localStorage.getItem('access_token'));

        const loginAsToken = localStorage.getItem('access_token_as');

        const [deviceId, location] = await Promise.all([
            getFingerprint(),
            []
        ]);

        config.headers = {
            ...config.headers,
            'X-DeviceId': deviceId,
            'X-Location-Lat': location?.lat,
            'X-Location-Lng': location?.lng,
        };

        if (storedToken?.accessToken) {
            config.headers = {
                ...config.headers,
                "Authorization": `Bearer ${storedToken.accessToken}`,
                "loginAsToken" : loginAsToken,
            };
        }

        return config;
    },
    (error) => Promise.reject(error)
);

requestv2.interceptors.response.use(
    (response) => response.data,
    async (error) =>
    {
        const config = error?.config;

        if (error?.response?.status === 401 && !config?.sent)
        {
            config.sent = true;

            const result = await memoizedRefreshToken();

            if (result?.accessToken)
            {
                config.headers = {
                    ...config.headers,
                    authorization: `Bearer ${result?.accessToken}`,
                };
            }
            else
            {
                localStorage.clear();
            }

            return requestv2(config);
        }
        return Promise.reject(error);
    }
);


export default requestv2;